import React, { useContext } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, CloseButton, Button, Text } from "@chakra-ui/react";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
import { deleteAsset } from "../../../../../utilies/GeojsonUtility";

const LayersDeleteDialog = () => {
  // state
  const deleteDialog = useAppStore((s) => s.deleteDialog);
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  // setters / refs
  const setDeleteDialog = useAppStore.getState().setDeleteDialog;

  const setImageGeojsonMode = useAppStore.getState().setImageGeojsonMode;
  const viewerRef = useAppStore.getState().viewerRef;
  const setCamera = useAppStore.getState().setCamera;

  return (
    <Dialog.Root
      lazyMount
      open={deleteDialog && deleteDialog.open ? true : false}
      onOpenChange={(e) => {
        setDeleteDialog({
          ...deleteDialog,
          open: e.open,
        });
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title> Delete Confirmation </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>{deleteDialog?.item?.is_edited ? "Do you want to discard changes?" : "Do you want to delete the layer?"}</Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                colorPalette={"red"}
                onClick={() => {
                  deleteAsset(viewerRef.current, deleteDialog.item, [mapObjects, setMapObjects], setImageGeojsonMode, setCamera);
                  setDeleteDialog({
                    item: null,
                    open: false,
                  });
                }}
              >
                Delete
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersDeleteDialog;
